// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAteth } from "../../../icons/full/build/icon-ateth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AtethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAteth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AtethIcon.displayName = 'AtethIcon';
}

export default AtethIcon;